import { render, staticRenderFns } from "./ReturnButton.vue?vue&type=template&id=40b9f236&scoped=true"
import script from "./ReturnButton.vue?vue&type=script&lang=js"
export * from "./ReturnButton.vue?vue&type=script&lang=js"
import style0 from "./ReturnButton.vue?vue&type=style&index=0&id=40b9f236&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b9f236",
  null
  
)

export default component.exports